// Augment catalog and ids

export const AugmentIds = Object.freeze({
  BOUNTY_HUNTER: 'bounty_hunter',
  PATHFINDER: 'pathfinder',
  TAXMAN: 'taxman',
  EXECUTIONER: 'executioner',
  VETERAN: 'veteran',
  JAILER: 'jailer',
  RECRUITER: 'recruiter',
  DEMAGOGUE: 'demagogue',
  CROWN_TAX: 'crown_tax',
  ROYAL_DECREE: 'royal_decree'
});

export const AUGMENTS = {
  // Color system: not rarity-based. Using named colors (red, orange, yellow, green, blue, purple, cyan).
  [AugmentIds.BOUNTY_HUNTER]: { id: 'bounty_hunter', name: 'Bounty Hunter', color: 'brown', priceGold: 5, effect: { type: 'triggered', triggers: ['onCapture'], handler: 'bountyHunter' } },
  [AugmentIds.PATHFINDER]: { id: 'pathfinder', name: 'Pathfinder', color: 'yellow', priceGold: 7, effect: { type: 'triggered', triggers: ['onMove','onGameEnd'], handler: 'pathfinder' } },
  // Renamed: Taxman -> Petitioner (keep id for compatibility)
  [AugmentIds.TAXMAN]: { id: 'taxman', name: 'Petitioner', color: 'cyan', priceGold: 5, effect: { type: 'triggered', triggers: ['onCheck'], handler: 'taxman' } },
  // Renamed: Executioner -> Kingslayer (keep id for compatibility)
  [AugmentIds.EXECUTIONER]: { id: 'executioner', name: 'Kingslayer', color: 'purple', priceGold: 12, effect: { type: 'triggered', triggers: ['onGameEnd'], handler: 'executioner' } },
  [AugmentIds.VETERAN]: { id: 'veteran', name: 'Veteran', color: 'gray', priceGold: 4, effect: { type: 'triggered', triggers: ['onSurvive'], handler: 'veteran' } },
  [AugmentIds.JAILER]: { id: 'jailer', name: 'Jailer', color: 'slate', priceGold: 13, effect: { type: 'triggered', triggers: ['onCapture'], handler: 'jailer' } },
  [AugmentIds.RECRUITER]: { id: 'recruiter', name: 'Recruiter', color: 'blue', priceGold: 3, effect: { type: 'triggered', triggers: ['onSurvive'], handler: 'recruiter' } },
  [AugmentIds.DEMAGOGUE]: { id: 'demagogue', name: 'Demagogue', color: 'orange', priceGold: 9, effect: { type: 'static', triggers: [], handler: 'demagogue' }, kingOnly: true },
  [AugmentIds.CROWN_TAX]: { id: 'crown_tax', name: 'Crown Tax', color: 'green', priceGold: 8, effect: { type: 'static', triggers: [], handler: 'crownTax' }, kingOnly: true },
  [AugmentIds.ROYAL_DECREE]: { id: 'royal_decree', name: 'Royal Decree', color: 'purple', priceGold: 5, effect: { type: 'static', triggers: [], handler: 'royalDecree' }, kingOnly: true }
};

// Augments available in the shop (subset of all augments)
export const AUGMENT_SHOP_ALLOWLIST = Object.freeze([
  AugmentIds.BOUNTY_HUNTER,
  AugmentIds.PATHFINDER,
  AugmentIds.TAXMAN,
  AugmentIds.EXECUTIONER,
  AugmentIds.VETERAN,
  AugmentIds.JAILER,
  AugmentIds.RECRUITER,
  AugmentIds.DEMAGOGUE,
  AugmentIds.CROWN_TAX,
  AugmentIds.ROYAL_DECREE
]);

